/**
 * Tips Retention Use Cases Factory
 *
 * @module @personnel/composition/factories/createTipsUseCases
 */

import type { AxiosInstance } from 'axios';
import type { TipsUseCases } from '@personnel/composition/types';

import { createTipsRetentionHttpClient } from '@personnel/infrastructure/api/TipsRetentionHttpClient';
import { updateTipsRetentionUseCase } from '@personnel/application/use-cases/UpdateTipsRetentionUseCase';

/**
 * Assembles all tips retention use cases with their injected dependencies.
 *
 * @param httpClient - Axios instance for the connect API
 * @returns Fully composed tips use cases
 */
export const createTipsUseCases = (httpClient: AxiosInstance): TipsUseCases => {
  const apiPort = createTipsRetentionHttpClient({ httpClient });

  return {
    updateTipsRetention: updateTipsRetentionUseCase({ apiPort }),
  };
};
